<template>
    <span>
          <v-btn icon class="mx-0" @click="deleteRefreshment()">
                      <v-icon color="pink">delete</v-icon>
          </v-btn>  
        </span>
</template>

<script>
import {deleteModule} from '@/model';

export default {
    name: 'DeleteRefreshment',
    props:{
        name :{
            required:true
        }
    },
    data() {
        return {
           
         
        };
    },
    methods: {
        deleteRefreshment() {
            let self=this;
            let confirmed =  confirm('Warning!!! \n This will delete this refreshment, do you continue?','Exodus','Yes','No');
    
            if(confirmed){
            
            deleteModule('refreshment',this.name,function(response){
              if(response){
                   console.log("This is response: ",response);
                     alert('Refreshment has been successfully deleted');
                    self.$store.dispatch('updateRefreshments'); 
                  }else{
                      console.log(null);
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>